import React from 'react';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { BrowserRouter as Router } from 'react-router-dom';

import { AuthProvider } from './contexts/AuthContext';
import { CompanyProvider } from './contexts/CompanyContext';

import Header from './components/Common/Header';
import Footer from './components/Common/Footer';

import AppRoutes from './routes/AppRoutes';

const theme = createTheme({
  palette: {
    mode: 'light',
    background: {
      default: '#ffffff',
      paper: '#ffffff',
    },
    primary: {
      main: '#111827',
    },
    secondary: {
      main: '#6b7280',
    },
    error: {
      main: '#ef4444',
    },
  },
  typography: {
    fontFamily: "'Poppins', 'Roboto', 'Helvetica Neue', Arial, sans-serif",
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 600,
    fontWeightBold: 800,
    h1: {
      fontSize: '3rem',
      fontWeight: 800,
      letterSpacing: '0.02em',
      lineHeight: 1.2,
    },
    h2: {
      fontSize: '2.25rem',
      fontWeight: 700,
      letterSpacing: '0.01em',
      lineHeight: 1.3,
    },
    h3: {
      fontSize: '1.875rem',
      fontWeight: 700,
      letterSpacing: '0.01em',
      lineHeight: 1.3,
    },
    body1: {
      fontSize: '1rem',
      color: '#6b7280',
      lineHeight: 1.5,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow:
            '0 4px 8px rgb(0 0 0 / 0.05)',
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <CompanyProvider>
          <Router>
            <Header />
            <main style={{ minHeight: 'calc(100vh - 128px)', paddingTop: 80, paddingBottom: 48 }}>
              <AppRoutes />
            </main>
            <Footer />
          </Router>
        </CompanyProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
